import { FetchAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { MyChartMedicinesInUseAliases } from '../../codegen';
import { FragmentNames } from '../../codegen';
import UserContext from '../../utils/user-context';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.MY_CHART_MEDICINES_IN_USE })
export default class MyChartMedicinesInUseController extends BaseController {

  @OnMount({ target: [
    MyChartMedicinesInUseAliases.FETCH_MEDICINES_IN_USE
  ] })
  handleFetchMedicinesInUseLoading(event: MountEvent): void {
    const fetchAPI = event.target as FetchAPI;
    fetchAPI.setParameters({ patientId: UserContext.patientId });
    fetchAPI.forceFetch();
  }

  @OnClick({ target: MyChartMedicinesInUseAliases.MY_CHART_MEDICINES_IN_USE_CARD })
  handleClickMedicineCard(event: ClickEvent): void {
    const { nrSequence } = event.value;
    applicationContext.redirect(APPLICATION_ROUTES.MY_CHART_MEDICINE_DETAIL, {
      nrSequence: nrSequence
    });
  }

}